import React from 'react'
import { FaUser } from "react-icons/fa"
import styled from "styled-components"
import { cpfSensibleMask } from "utils";

interface CardIdentificationProps {
  name?: string;
  document?: string;
}

const CardIdentification = ({ name, document }: CardIdentificationProps) => {
  return (
    <IdentificationCard>
      <UserIconWrapper>
        <FaUser height={24} color="#999" />
      </UserIconWrapper>
      <UserInfo>
        <UserName>{name}</UserName>
        <UserDocument>{cpfSensibleMask(document || "")}</UserDocument>
      </UserInfo>
    </IdentificationCard>
  )
}

const Card = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

const IdentificationCard = styled(Card)`
  gap: 16px;
`

const UserIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const UserInfo = styled.div`
  flex: 1;
`

const UserName = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #6B7280;
  margin-bottom: 4px;
`

const UserDocument = styled.div`
  font-size: 13px;
  color: #212121;
  font-weight: 700;
`

export default CardIdentification